// extracted by mini-css-extract-plugin
export default {"modal":"BotProtect_modal__V9Icn","text":"BotProtect_text__9LZgl","continueBtn":"BotProtect_continueBtn__P6UUS"};